import YouTubeSdk from './youTube';
const youTube = new YouTubeSdk();

export default youTube;



// WEBPACK FOOTER //
// ./src/lib/you-tube/index.js